'use strict'

export default class ResponsiveNavigation {
  init () {
    this.eventListenerSetup()
  }

  eventListenerSetup() {
    const hamburgers = document.querySelectorAll(".hamburger");

    hamburgers.forEach((hamburger) => {
      hamburger.addEventListener("click", function() {
        this.classList.toggle("is-active");

        const responsiveNav = document.getElementById('responsive-navigation');
        if (responsiveNav) {
          responsiveNav.classList.toggle('show');
        }
      });
    });

    const dropdownTogglesResponsive = document.querySelectorAll('.main-link i');

    dropdownTogglesResponsive.forEach(toggle => {
      const dropdownMenu = toggle.parentNode.parentNode.querySelector('ul');
      toggle.addEventListener('click', function(event) {

        // Rotate the icon
        toggle.classList.toggle('rotated');

        // Close other open dropdowns
        document.querySelectorAll('.main-link i').forEach(otherToggle => {
          if (otherToggle !== toggle) {
            otherToggle.classList.remove('rotated');
            const otherDropdownMenu = otherToggle.parentNode.parentNode.querySelector('ul');
            if (otherDropdownMenu && otherDropdownMenu !== dropdownMenu) {
              otherDropdownMenu.classList.remove('is-open');
            }
          }
        });

        // Toggle the clicked dropdown
        if (dropdownMenu) {
          event.preventDefault();
          dropdownMenu.classList.toggle('is-open');
        }
      });
    })
  }
}
